import React, { Component } from "react";

import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import overlayFactory from "react-bootstrap-table2-overlay";

import _ from "lodash";
import { MdSearch } from "react-icons/md";

import { Helmet } from "react-helmet";
import { Accordion, Button, Card } from "react-bootstrap";
import moment from "moment";
import {
  getVirtualBankList,
  exportVirtualBankList,
} from "app/services/AdminServices/bankService";
import { useState, useEffect } from "react";

import queryStringService from "app/services/queryStringService";
import { AiFillFileExcel } from "react-icons/ai";
import HandyScroll from "app/common/Scroll";

const VirtualBankList = () => {
  const dateTimeFormat = "YYYY-MM-DD HH:mm:ss";

  const [state, setState] = useState({
    page: 1,
    data: [],
    sizePerPage: 10,
    dataCount: 0,
    loading: true,
    FromDate: "",
    ToDate: "",
    SearchType: "",
  });

  useEffect(() => {
    loadVirtualBankList();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [
    state.page,
    state.sizePerPage,
    // state.FromDate,
    // state.ToDate,
    // state.SearchType,
  ]);

  const dateFormatter = (cell, row) => {
    return moment(cell).format(dateTimeFormat);
  };
  const balanceFormatter = (cell, row) => {
    return (
      <span className="text-center">
        ₹ {parseFloat(row.txnAmount).toFixed(2)}
      </span>
    );
  };
  const columns = [
    {
      dataField: "id",
      text: "Sln.",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "member.uniqueIdentity",
      text: "Username",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
    },
    {
      dataField: "virtualBankId",
      text: "virtual Bank Id",
      headerStyle: (colum, colIndex) => {
        return {
          width: "200px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "member.company",
      text: "Company",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
    },
    {
      dataField: "resDate",
      text: "Date",
      headerStyle: (colum, colIndex) => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
      formatter: dateFormatter,
    },
    {
      dataField: "txnAmount",
      text: "Trn Amount",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: balanceFormatter,
    },
    {
      dataField: "resCode",
      text: "Res Code",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },

    {
      dataField: "status",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "referenceNo",
      text: "Ref No.",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "corelationId",
      text: "Corelation Id",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
    },
    {
      dataField: "txnId",
      text: "Trn Id",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    const { loading } = state;
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadVirtualBankList = async (pageParam, sizePerPageParam) => {
    const { page, sizePerPage, FromDate, ToDate, SearchType } = state;
    const query = queryStringService.getQueryStringFromObj({
      pageNumber: pageParam ? pageParam : page,
      pageSize: sizePerPageParam ? sizePerPageParam : sizePerPage,
      FromDate,
      ToDate,
      SearchType,
    });

    if (state.dataCount !== 0) {
      setState((prevState) => ({ ...prevState, loading: true }));
    }

    const response = await getVirtualBankList(query);

    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setState((prevState) => ({
      ...prevState,
      loading: false,
      data,
      dataCount: paggingData.TotalCount,
      page: paggingData.CurrentPage,
      sizePerPage: paggingData.PageSize,
    }));
  };

  const resetTableHandler = async () => {
    const { page, sizePerPage, FromDate, ToDate, SearchType } = state;
    const query = queryStringService.getQueryStringFromObj({
      pageNumber: 1,
      pageSize: 10,
    });

    if (state.dataCount !== 0) {
      setState((prevState) => ({ ...prevState, loading: true }));
    }

    const response = await getVirtualBankList(query);

    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setState((prevState) => ({
      ...prevState,
      loading: false,
      data,
      dataCount: paggingData.TotalCount,
      page: paggingData.CurrentPage,
      sizePerPage: paggingData.PageSize,
    }));
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    await loadVirtualBankList(page, sizePerPage);
  };

  const handleSearch = async () => {
    setState((prevState) => ({
      ...prevState,
      page: 1,
      sizePerPage: 10,
    }));

    setTimeout(async () => {
      await loadVirtualBankList();
    }, 10);
  };

  const handleExport = async () => {
    setState((prevState) => ({
      ...prevState,
      page: 1,
      sizePerPage: 10,
    }));

    setTimeout(async () => {
      await exportAllLedger();
    }, 10);
  };

  const exportAllLedger = async () => {
    const { page, sizePerPage, FromDate, ToDate, SearchType } = state;
    const query = queryStringService.getQueryStringFromObj({
      FromDate,
      ToDate,
      SearchType,
    });

    if (state.dataCount !== 0) {
      setState((prevState) => ({ ...prevState, loading: true }));
    }

    const response = await exportVirtualBankList(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${moment().toISOString()}_ladger.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setState((prevState) => ({
      ...prevState,
      loading: false,
    }));
  };

  const handleSearchChanges = (e) => {
    setState((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const refreshFilter = async (e) => {
    setState((prevState) => ({
      ...prevState,
      FromDate: "",
      ToDate: "",
      SearchType: "",
    }));
    await resetTableHandler();
  };

  const {
    data,
    sizePerPage,
    page,
    dataCount,
    loading,
    FromDate,
    ToDate,
    SearchType,
  } = state;

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary h-75" : "btn-light h-75"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <Helmet>
        <title>Virtual Transaction List</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "Virtual Transaction List" }]}
      ></Breadcrumb>

      <div className="card card-body text-left " id="VirtualTransactionList">
        <div className="card-body p-0 mr-2 ">
          <div className=" mx-auto">
            <div className="bookingList-header">
              <div className="row ">
                <div className="col-md-3 col-12">
                  <div className="form-group">
                    <label> Date From</label>
                  </div>
                  <input
                    type="date"
                    className="form-control"
                    name="FromDate"
                    value={FromDate}
                    onChange={handleSearchChanges}
                    max={moment().format("YYYY-MM-DD")}
                  />
                </div>
                <div className="col-md-3 col-12">
                  <div className="form-group">
                    <label> Date To</label>
                  </div>
                  <input
                    type="date"
                    className="form-control"
                    name="ToDate"
                    value={ToDate}
                    onChange={handleSearchChanges}
                    max={moment().format("YYYY-MM-DD")}
                  />
                </div>
                <div className="col-md-3 col-12">
                  <div className="form-group">
                    <label> Search by Username</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    name="SearchType"
                    value={SearchType}
                    onChange={handleSearchChanges}
                  />
                </div>
                <div
                  className="col d-flex justify-content-center mb-3"
                  style={{ marginTop: "3%" }}
                >
                  <button
                    className="btn btn-outline-primary"
                    onClick={handleSearch}
                  >
                    <MdSearch className="" size={18} />
                  </button>
                  <button
                    className="btn btn-primary mx-2"
                    onClick={refreshFilter}
                  >
                    Refresh
                  </button>
                  <Button
                    variant="outline-primary"
                    onClick={handleExport}
                    disabled={!dataCount}
                  >
                    Export
                    <AiFillFileExcel className="ms-1" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <HandyScroll>
            <div
              class="spacious-container"
              data-handy-scroll
              style={{ overflow: "auto" }}
            >
              <BootstrapTable
                hover
                remote
                keyField="sln"
                data={data}
                columns={columns}
                pagination={
                  dataCount > 0 && paginationFactory(paginationOptions)
                }
                onTableChange={handleTableChange}
                noDataIndication={() => <NoDataIndication />}
                loading={loading}
                // overlay={overlayFactory({
                //   spinner: true,
                //   styles: {
                //     overlay: (base) => ({
                //       ...base,
                //       background: "rgba(120, 120, 120, 0.5)",
                //       zIndex: "1",
                //     }),
                //   },
                // })}
                headerClasses="bg-primary text-white"
                bodyClasses="react-bootstrap-table-next-min-height"
                rowStyle={rowStyle}
              />
            </div>
          </HandyScroll>
        </div>
      </div>
    </>
  );
};

export default VirtualBankList;
